// src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';
import homePage from '../components/HomePage.vue';
import PdfTools from '../components/PdfTools.vue';
import ImageTools from '../components/ImageTools.vue';
import CodecTools from '../components/CodecTools.vue';
import Tasks from '../components/Tasks.vue';
import OcrPage from '../components/OcrPage.vue';
import { applyRouteMeta } from '../utils/seo.js';
// 网页版已移除注册 / 登录：AuthPage、AccountPage 不再引入

// 使用 Vue Router
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'homePage',
    component: homePage
  },
  {
    path: '/pdf-tools',
    name: 'pdfTools',
    component: PdfTools
  },
  {
    path: '/image-tools',
    name: 'imageTools',
    component: ImageTools
  },
  {
    path: '/codec-tools',
    name: 'codecTools',
    component: CodecTools
  },
    {
      path: '/ocr',
      name: 'ocrPage',
      component: OcrPage
    },
    {
      path: '/tasks',
      name: 'tasks',
      component: Tasks
    },
    // 网页版已移除注册 / 登录：旧收藏链接兜底回首页，避免 404
    {
      path: '/login',
      redirect: '/'
    },
    {
      path: '/account',
      redirect: '/'
    },
  // 兜底重定向到首页
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  mode: 'history', // 使用历史模式
  // 工具站部署在 tools.ceanx.com 根路径，无需 base 前缀
  routes
});

// SPA 各路由共用一份 index.html —— 靠这里给每个工具页写上自己的
// title / description / canonical / og，否则整站标题都一样，毫无关键词区分度。
router.afterEach((to) => {
  applyRouteMeta(to.path);
});

export default router;